import './css/homepage_org.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoginSignup from "./components/LoginSignup";

function LoginOrganiser () {
	
return (
	<div className="home-container">
	<Header/>
	
	<main className="home-main">
	<section className="home-title">
	  <h1>Manage, Sell, and Monitor Event tickets with ease.</h1>
	  <p>Please login or sign up to continue.</p>
	</section>
	  <div className="login-box">
	    <LoginSignup />
	  </div>

	</main>
	
	<Footer/>
	</div>
)
}
export default LoginOrganiser;


